import { Component }                 from '@angular/core';
import { RequestCompleteListState }  from '@core/interfaces/api.interface';
import { ENTITY_TYPE }               from '@core/interfaces/entity.interface';
import { SelectFilterBaseComponent } from '@shared/list-operations/components/select-filters/select-filter-base/select-filter-base.component';
import {
	ISelectFilterable,
	SelectFilterModeEnum
}                                    from '@shared/list-operations/model/filter.model';
import {
	Observable,
	of
}                                    from 'rxjs';

@Component( {
	selector: 'app-select-filter-items',
	templateUrl: './../select-filter-base/select-filter-base.component.html'
} )
export class SelectFilterItemsComponent extends SelectFilterBaseComponent implements ISelectFilterable {

	constructor() {
		super();
		this.selectFilterMode = SelectFilterModeEnum.STATIC_LIST;
	}

	searchRequestCallback = (): Observable<RequestCompleteListState<ENTITY_TYPE>> => {
		return of( this.getNotAskedRequestCompleteListState<ENTITY_TYPE>() );
	};
}
